// extracted by mini-css-extract-plugin
export default {"v-standardBorder":"1px solid #D8D8D8","root":"popover__root__Ihgsv"};